import React from "react";
import MaterialIcon from "../../BuilderComponents/MaterialIcon";

export const REACT_FLOW_TOOL_ACTION = {
  ZOOM_IN: "ZOOM_IN",
  ZOOM_OUT: "ZOOM_OUT",
  MOVE_UP: "MOVE_UP",
  M0VE_DOWN: "M0VE_DOWN"
};

const ToolPanel = ({ callback }) => {
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div className="sm_blueprint_functionboxOut no-select flex_row">
        <MaterialIcon name="zoom_in" title="zoom in" onClick={() => callback(REACT_FLOW_TOOL_ACTION.ZOOM_IN)} />
        <hr></hr>
        <MaterialIcon name="zoom_out" title="zoom out" onClick={() => callback(REACT_FLOW_TOOL_ACTION.ZOOM_OUT)} />
        <hr></hr>
        <MaterialIcon name="arrow_upward" title="move up" onClick={() => callback(REACT_FLOW_TOOL_ACTION.MOVE_UP)} />
        <hr></hr>
        <MaterialIcon
          name="arrow_downward"
          title="move down"
          onClick={() => callback(REACT_FLOW_TOOL_ACTION.M0VE_DOWN)}
        />
      </div>
    </div>
  );
};

export default ToolPanel;
